import { useContext, useEffect, useState, type FC } from 'react';
import type { ShopSchema } from 'src/models/shop/schema';
import { I18nContext } from 'src/stores/I18n';
import type { ShopModalMode } from './type';

type Props = {
  mode: ShopModalMode;
  shop?: ShopSchema;
};

export const ShopModalTitle: FC<Props> = ({ mode, shop }) => {
  const localeResources = useContext(I18nContext);
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (mode === 'list') {
      setTitle(localeResources.receive.list.selectPickupLocation);
    } else if (mode === 'vjw') {
      setTitle(localeResources.receive.vjw.pleaseCheck);
    } else {
      // mode === 'detail'
      setTitle(shop?.name ?? '');
    }
  }, [localeResources, mode, shop?.name]);

  return <div className="text-center font-medium py-5">{title}</div>;
};
